export const environment = {
    production: true,
    hmr: false,
    gqlUrl: 'https://gql.spekwo.com/graphql',
    website: 'https://www.spekwo.com/',
    displayWebsite: 'www.spekwo.com',
    email: 'hello@speKwo.com',
    apiHost: 'https://backup.api.spekwo.com/',
    customerUrl: 'https://backup.client.spekwo.com/',
    displayCusUrl: 'backup.client.spekwo.com ',
    wpCouponSite: 'https://www.spekwo.com/wp-admin/edit.php?post_type=shop_coupon',
    picStories: 'https://backup.api.spekwo.com/PictureStories/'
};



// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/environments/environment.ts